import { render, staticRenderFns } from "./createLiveModal.vue?vue&type=template&id=d5b994c8&scoped=true"
import script from "./createLiveModal.vue?vue&type=script&lang=js"
export * from "./createLiveModal.vue?vue&type=script&lang=js"
import style0 from "./createLiveModal.vue?vue&type=style&index=0&id=d5b994c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b994c8",
  null
  
)

export default component.exports